import { AxiosError } from "axios";
import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../../interceptors/axios";
import { Result } from "../../../types/Result";

export const confirmEmailLoader: LoaderFunction = async (args) => {
    const url = new URLSearchParams(new URL(args.request.url).search);
    const token = url.get("token");
    const email = url.get("email");
    if (!token || !email) throw new Error("Hatalı erişim adresi");
    try {
        await axiosApi.post<Result<string>>("/api/auth/confirm-email", { email, token });
    } catch (error) {
        if (error instanceof AxiosError && error.response?.data?.errors && Array.isArray(error.response?.data?.errors)) {
            throw new Error(error.response?.data?.errors[0]);
        }
        throw new Error("Bilinmeyen bir hata oluştu");
    }
    return true;
}